import { create } from 'zustand';

/**
 * Çevrim içi kullanıcı presence state'i (singleton store).
 * `OnlineStatusProvider` echo presence kanalını dinleyip bu store'u günceller.
 * Tüketiciler `s.onlineUserIds.has(id)` selector'ı ile sadece ilgilendikleri
 * kullanıcının durumu değiştiğinde re-render olabilir.
 */
interface OnlineStatusState {
  onlineUserIds: Set<number>;
  setOnlineUserIds: (ids: Set<number>) => void;
  addOnlineUser: (id: number) => void;
  removeOnlineUser: (id: number) => void;
}

export const useOnlineStatusStore = create<OnlineStatusState>((set) => ({
  onlineUserIds: new Set(),
  setOnlineUserIds: (ids) => set({ onlineUserIds: ids }),
  addOnlineUser: (id) =>
    set((s) => {
      if (s.onlineUserIds.has(id)) return s;
      const next = new Set(s.onlineUserIds);
      next.add(id);
      return { onlineUserIds: next };
    }),
  removeOnlineUser: (id) =>
    set((s) => {
      if (!s.onlineUserIds.has(id)) return s;
      const next = new Set(s.onlineUserIds);
      next.delete(id);
      return { onlineUserIds: next };
    }),
}));
